import React, { useEffect, useState } from "react";
import Modal from "@/components/controls/Modal";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import SingleCheckbox from "@/components/ui/SingleCheckbox";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => void;
}

const TRANSLATION_KEY =
  "settings.partners.generalTab.partnerPortal.disableModal";

const DisablePartnersModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  onConfirm
}) => {
  const { t } = useTranslation();
  const [acknowledged, setAcknowledged] = useState(false);

  useEffect(() => {
    if (!isOpen) setAcknowledged(false);
  }, [isOpen]);

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      setIsOpen={setIsOpen}
      data-test="disable-partners-modal"
      contentClassname="w-[35rem]"
      title={
        <Text as="div" variant="lgSubtitleH1">
          {t(`${TRANSLATION_KEY}.title`)}
        </Text>
      }
      content={
        <div className="flex flex-col gap-2 p-4">
          <Text variant="body">{t(`${TRANSLATION_KEY}.paragraph1`)}</Text>
          <Text variant="body">{t(`${TRANSLATION_KEY}.paragraph2`)}</Text>
          <Text variant="body">{t(`${TRANSLATION_KEY}.paragraph3`)}</Text>
          <SingleCheckbox
            id="disable-partners-acknowledge"
            label={t(`${TRANSLATION_KEY}.acknowledge`)}
            isChecked={acknowledged}
            onCheckedChange={setAcknowledged}
          />
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button
            variant="secondary"
            onClick={handleCancel}
            data-test="disable-partners-modal-cancel"
          >
            {t(`${TRANSLATION_KEY}.cancel`)}
          </Button>
          <Button
            destructive
            disabled={!acknowledged}
            onClick={handleConfirm}
            data-test="disable-partners-modal-confirm"
          >
            {t(`${TRANSLATION_KEY}.confirm`)}
          </Button>
        </div>
      }
    />
  );
};

export default DisablePartnersModal;
